import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { UserMessageResponseData } from "@/lib/nut/UserMessageResponseData";

export interface BuilderMessageState {
  lastMessageResponse?: UserMessageResponseData;
  numInteractionsProcessed?: number;
}

const initialState: BuilderMessageState = {};

const builderMessageSlice = createSlice({
  name: "builderMessage",
  initialState,
  reducers: {
    setLastMessageResponse: (state, action: PayloadAction<UserMessageResponseData | undefined>) => {
      state.lastMessageResponse = action.payload;
      state.numInteractionsProcessed = undefined;
    },
    setNumInteractionsProcessed: (state, action: PayloadAction<number>) => {
      state.numInteractionsProcessed = action.payload;
    },
    clearLastMessageResponse: (state) => {
      state.lastMessageResponse = undefined;
      state.numInteractionsProcessed = undefined;
    },
  },
});

export const { setLastMessageResponse, setNumInteractionsProcessed, clearLastMessageResponse } = builderMessageSlice.actions;
export default builderMessageSlice.reducer;
